import PropTypes from 'prop-types';
import { logout } from '../../../auth/oauth2Service.js';

const TopBar = (props) => {
  const { getComponent, pagoAuth2Selectors, pagoAuth2Actions, userRole, backendSpecsActions, backendSpecsSelectors, editorSelectors } = props;
  const Logo = getComponent('TopBarLogo');
  const PrimeMenu = getComponent('PrimeMenu', true);
  const EnvironmentIndicator = getComponent('TopBarEnvironmentIndicator', true);

  return (
    <div className="swagger-editor__top-bar">
      <div className="swagger-editor__top-bar-wrapper">
        <Logo />
        {PrimeMenu ? (
          <PrimeMenu
            getComponent={getComponent}
            backendSpecsActions={backendSpecsActions}
            backendSpecsSelectors={backendSpecsSelectors}
            pagoAuth2Selectors={pagoAuth2Selectors}
            pagoAuth2Actions={pagoAuth2Actions}
            userRole={userRole}
            editorSelectors={editorSelectors}
          />
        ) : (
          <div style={{ color: 'white', padding: '0 1rem' }}>
            Menu loading...
          </div>
        )}
        {EnvironmentIndicator && <EnvironmentIndicator />}
        <button className="logout-button" onClick={logout}>Logout</button>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  getComponent: PropTypes.func.isRequired,
  pagoAuth2Selectors: PropTypes.object,
  pagoAuth2Actions: PropTypes.object,
  userRole: PropTypes.string,
  backendSpecsActions: PropTypes.object,
  backendSpecsSelectors: PropTypes.object,
  editorSelectors: PropTypes.object,
};

TopBar.defaultProps = {
  pagoAuth2Selectors: null,
  pagoAuth2Actions: null,
  userRole: null,
  backendSpecsActions: null,
  backendSpecsSelectors: null,
  editorSelectors: null,
};

export default TopBar;



